import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img3.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="FerrousMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Ferrous Metal Scrap
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                FERROUS METALS
                </div>
                <div className='Each-Product-mid-details'>
                Our ferrous metal scrap products, containing iron and magnetic properties, are ideal for construction, manufacturing, and infrastructure projects. These materials ensure durability, versatility, and sustainability, supporting various industrial applications while promoting eco-friendly practices through efficient recycling and resource utilization.
                                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Import Scrap</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Steel Scrap",
      description: "We supply a variety of steel scrap grades, including heavy melt, shredded scrap, and scrap from old appliances, ensuring you get the best material for your recycling or production needs.",
      image: "/Products/Ferrous/1.png"
    },
    {
      title: "Cast Iron Scrap",
      description: "Ideal for foundries and other industrial applications, our cast iron scrap is sourced from high-quality, reliable sources.",
      image: "/Products/Ferrous/2.jpg"
    },
    {
      title: "Copper Car Bodies and End-of-Life Vehicles (ELVs)",
      description: "We specialize in purchasing scrap from old vehicles and offer clean, high-value metal for recycling or reprocessing.",
        image: "/Products/Ferrous/3.jpg"
    },

    
  ];
  